/**
 *  Preview & PreviewIntensity
 *  Currently Implemented only by Albums.
 *  Could be used as is by Stems.
 */
/**
 * Represent the preview of an Asset.
 * @note Currently Implemented only by Albums. Could be used as is by Stems.
 * @class
 */
class Preview {
    constructor() {
        this.creationState = null;
        this.defaultIntensity = null;
        this.defaultStyle = null;
        this.engineVersion = null;
        this.estimatedTimeToCompletionInMS = null;
        this.intensities = [];
        this.isTooLoud = false;
        this.originalStream = null;
    }
}
/**
 * Represent a preview intensity object
 * @note Currently Implemented only by Albums. Could be used as is by Stems.
 * @class
 */
class PreviewIntensity {
    constructor() {
        this.intensity = null;
        this.stream = null;
        this.style = null;
        this.volumeRatio = null;
    }
}
const keysOfPreview = ["creationState", "defaultIntensity", "defaultStyle", "engineVersion", "estimatedTimeToCompletionInMS", "intensities", "isTooLoud", "originalStream"];

export { Preview, PreviewIntensity, keysOfPreview };
